module.exports = __webpack_public_path__ + "files/d478f1969ff175e8a04b1b79e396a4d3.png";